module.exports = __webpack_public_path__ + "static/basen-prosto_thumb-62710686b3acde2572c5459ffe1c3ec5.jpg";